import { useOrganization } from 'hooks';
import { maxBy } from 'lodash';

export default function useCurrentOrganizationOvertimePeriod() {
  const { organizationOvertimePeriods } = useOrganization();
  return maxBy(organizationOvertimePeriods ?? [], (period) => period.startTime);
}
